export default {
  /**
   * Design API
   */
  designApi: {
    url: 'https://cluster.mycs.ninja/api/designs/',
  },

  /**
   * Order API
   */
  orderApi: {
    url: 'https://cluster.mycs.ninja/api/orders/',
  },

  /**
   * User API
   */
  userApi: {
    url: 'https://cluster.mycs.ninja/api/users/',
  },
}



// WEBPACK FOOTER //
// ./src/config/config.development.js